module.exports = __webpack_public_path__ + "img/ic-visa.d2fb9fc1.svg";